import { dimensions } from '@/mocks/home';

export default function CompareDimensions() {
  return (
    <section id="dimensions" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 mb-4">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-stack-line" />
            </span>
            对比维度
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
            六个维度，把「相似」拆成看得见的差别
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            与其说哪家更好，不如说哪家更适合你。把下面六项对着候选的站点逐条对照，答案通常自己就浮出来了。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-2">
          {dimensions.map((dim) => (
            <div
              key={dim.id}
              className="flex items-start gap-4 py-6 border-b border-background-300/60"
            >
              <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${dim.icon} text-lg`} />
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {dim.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{dim.summary}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}